import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import styled from "styled-components";
import { Home } from "./components/Home/Home";
import { media } from "./styles/mixins";
import { COLORS, CONTAINER_WIDTHS } from "./assets/constants/styles";
import { Header } from "./components/Header/Header";
import { initializeAmplitude } from "./helpers/analytics-helpers";

const App = () => {
  initializeAmplitude();

  return (
    <AppContainer>
      <Header />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </Router>
    </AppContainer>
  );
};

const AppContainer = styled.div`
  font-family: "Manrope", sans-serif;
  color: ${COLORS.black};
  font-weight: 500;
  // box-sizing: border-box;
  // margin-left: auto;
  // margin-right: auto;

  // width: 100%;
  // margin: 0 auto;

  // max-width: ${CONTAINER_WIDTHS.mobile}px;

  // ${media.tablet(`
  //   max-width: ${CONTAINER_WIDTHS.tablet}px;
  // `)}

  // ${media.laptop(`
  //   max-width: ${CONTAINER_WIDTHS.laptop}px;
  // `)}

  // ${media.desktop(`
  //   max-width: ${CONTAINER_WIDTHS.desktop}px;
  // `)}
`;

export default App;
